import React from 'react';

const VARIABLES_BY_MODULE = {
  CRM: [
    'contactName', 'companyName', 'senderName', 'senderPhone', 'agencyName', 'industry',
  ],
  ATS: [
    'candidateName', 'jobRole', 'clientName', 'interviewDate', 'interviewTime',
    'interviewMode', 'interviewLink', 'ctcRange', 'jobLocation', 'senderName', 'agencyName',
  ],
  INVOICE: [
    'clientName', 'invoiceNo', 'invoiceAmount', 'dueDate', 'paymentTerms',
    'candidateName', 'jobRole', 'senderName', 'agencyName',
  ],
};

const VariablePicker = ({ module, onInsert }) => {
  const vars = VARIABLES_BY_MODULE[module] || [];

  if (vars.length === 0) return null;

  return (
    <div>
      <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2">
        Insert variable:
      </p>
      <div className="flex flex-wrap gap-1.5">
        {vars.map((v) => (
          <button
            key={v}
            type="button"
            onClick={() => onInsert(`{${v}}`)}
            className="px-2 py-1 text-xs bg-blue-50 text-blue-700 border border-blue-200 rounded-md hover:bg-blue-100 transition-colors font-mono"
          >
            {`{${v}}`}
          </button>
        ))}
      </div>
    </div>
  );
};

export default VariablePicker;
